module.exports = __webpack_public_path__ + "img/e312333.png";